import { render, staticRenderFns } from "./CalorimetrySpecificHeatCapacityOfMetal.vue?vue&type=template&id=04a4273d&"
import script from "./CalorimetrySpecificHeatCapacityOfMetal.vue?vue&type=script&lang=js&"
export * from "./CalorimetrySpecificHeatCapacityOfMetal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports